export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SET_AUTH_PROMISE = 'SET_AUTH_PROMISE';
export const ADD_USER = 'ADD_USER';
